import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_immo-sales/artifacts/fd8qldce_immostaging1%20png.png";

export default function Footer() {
  return (
    <footer className="bg-zinc-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="IMMOSTAGING" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-zinc-400 text-sm leading-relaxed max-w-md">
              IMMOSTAGING, votre agence immobilière de confiance. 
              Nous vous accompagnons dans tous vos projets immobiliers 
              avec professionnalisme et transparence.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4 font-['Outfit']">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-zinc-400 hover:text-[#D62965] transition-colors text-sm" data-testid="footer-link-accueil">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/ventes" className="text-zinc-400 hover:text-[#D62965] transition-colors text-sm" data-testid="footer-link-ventes">
                  Nos Biens
                </Link>
              </li>
              <li>
                <Link to="/honoraires" className="text-zinc-400 hover:text-[#D62965] transition-colors text-sm" data-testid="footer-link-honoraires">
                  Honoraires
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 hover:text-[#D62965] transition-colors text-sm" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-zinc-400 hover:text-[#D62965] transition-colors text-sm" data-testid="footer-link-mentions">
                  Mentions Légales
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4 font-['Outfit']">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-zinc-400 text-sm">
                <MapPin className="h-4 w-4 mt-0.5 text-[#00B5AD] flex-shrink-0" />
                <span>Route du Regage<br />13124 Peypin</span>
              </li>
              <li>
                <a href="mailto:contactsite@immostaging.fr" className="flex items-center gap-3 text-zinc-400 hover:text-[#D62965] transition-colors text-sm" data-testid="footer-email">
                  <Mail className="h-4 w-4 text-[#00B5AD]" />
                  <span>contactsite@immostaging.fr</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-xs">
            © {new Date().getFullYear()} IMMOSTAGING. Tous droits réservés. SIRET: 89234468000012
          </p>
          <div className="flex gap-4 text-xs text-zinc-500">
            <Link to="/mentions-legales" className="hover:text-[#D62965] transition-colors">
              Mentions Légales
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
